import { render, staticRenderFns } from "./CobranzaDetail.vue?vue&type=template&id=3b62d078&scoped=true"
import script from "./CobranzaDetail.vue?vue&type=script&lang=js"
export * from "./CobranzaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b62d078",
  null
  
)

export default component.exports